var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('xyz-transition-group',_vm._b({attrs:{"appear-visible":{
    threshold: [_vm.threshold],
  },"xyz":"fade down stagger"}},'xyz-transition-group',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }